// Module
var code = "<react-component name=\"EditGradingEvent\"></react-component>\n";
// Exports
module.exports = code;